
import { CompanyMemberTypeEnum } from "./CompanyMemberTypeEnum"
export function describeCompanyMemberTypeEnum(e: CompanyMemberTypeEnum): string{
    switch(e){
        case CompanyMemberTypeEnum.MainAdmin:
            return "主管理员";
        case CompanyMemberTypeEnum.SubAdmin:
            return "副管理员";
        case CompanyMemberTypeEnum.Member:
            return "普通成员";
        default:
            throw new Error(`${e} is an invalid CompanyMemberTypeEnum`);
    }
}
		